module.exports = __webpack_public_path__ + "img/project2.60284905.jpg";